import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import "../styles/App.css";
import { validateName, validateUsername } from "../components/RegExs";
import { APIBaseLink } from "../components/APIBaseLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SignupPage() {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [role, setRole] = useState("patient");
	const [showPassword, setShowPassword] = useState(false);
	const [passwordError, setPasswordError] = useState("");
	const [usernameError, setUsernameError] = useState("");
	const [emailError, setEmailError] = useState("");
	const [entryError, setEntryError] = useState("");
	const [mfa, setMfa] = useState("");
	const navigate = useNavigate();

	const API_BASE_LINK = APIBaseLink();

	const validatePassword = (password) => {
		//Password needs 1 Uppercase letter, 1 digit, and 1 non-word character of at least 8 chars in length
		const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/;
		return regex.test(password);
	};

	const handleSignup = async (e) => {
		e.preventDefault();
		setEntryError("Registering Account...");

		setPasswordError("");
		setUsernameError("");
		setEmailError("");
		setEntryError("");

		try {
			if (!validatePassword(password)) {
				setPasswordError("Password must be at least 8 characters long, contain 1 uppercase letter, 1 number, and 1 symbol.");
        return;
			}

			if (!validateName(firstName) || !validateName(lastName)) {
				setEntryError("Names must be only characters");
        return;
			}

			if (!validateUsername(username)) {
				setUsernameError("Username must not include special characters");
        return;
			}

			var obj = { Username: username, Password: password, firstName: firstName, lastName: lastName, Email: email, role: role, mfaEnabled: mfa };
			var js = JSON.stringify(obj);
			console.log(obj);

			const response = await fetch(`${API_BASE_LINK}/user/register`, {
				method: "POST",
				body: js,
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				const res = await response.json();
				console.log("User signed up!");
				navigate("/login");
			} else {
				console.log("Signup failed, please check your details.");
				const res = await response.json();
				console.log("Response from server:", res);
				if (res.message === "Username already exists") setUsernameError("Username already exists");
				if (res.message === "Email already exists") setEmailError("Email already exists");
				if (res.message === "Invalid email format") setEmailError("Invalid email format");
				if (res.message === "All fields are required") setEntryError("Please enter a value for all fields");
			}
		} catch (err) {
			console.log("Error during signup:", err);
			toast.error("An Error Occured.");
		}
	};

	const toggleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	return (
			<div className="form-page">
				<h1>Sign Up</h1>
				<form onSubmit={handleSignup}>
					{entryError && <p classname="entry-error">{entryError}</p>}
					<div className="name-fields">
						<div className="form-group">
							<label>First Name:</label>
							<input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
						</div>
						<div className="form-group">
							<label>Last Name:</label>
							<input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
						</div>
					</div>
					<div className="form-group">
						<label>Email:</label>
						<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
						{emailError && <p className="username-error">{emailError}</p>}
					</div>
					<div className="form-group">
						<label>Username:</label>
						<input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
						{usernameError && <p className="username-error">{usernameError}</p>}
					</div>
					<div className="form-group">
						<label>Password:</label>
						<div className="password-input-container">
							<input
								className="password-input"
								type={showPassword ? "text" : "password"}
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
							/>
							<img src={showPassword ? "/visible.png" : "/hide.png"} alt="Toggle visibility" onClick={toggleShowPassword} className="password-toggle-icon" />
						</div>
						<p className="password-requirements">At least 8 characters, 1 uppercase letter, 1 number & 1 symbol</p>
						{passwordError && <p className="password-error">{passwordError}</p>}
					</div>
					<div className="form-group">
						<label>Enable Multi-Factor Authentication?</label>
						<select className="checkBox" type="checkbox" value={mfa} onChange={(e) => setMfa(e.target.value)} required defaultValue={""}>
							<option value=""></option>
							<option value="true">Yes</option>
							<option value="false">No</option>
						</select>
						<p className="MFA-notice">You can change this at any time on the Profile page.</p>
					</div>
					<button type="submit">Sign Up</button>
				</form>
				<p>
					Already have an account? <a href="/login">Log in!</a>
				</p>
			</div>
	);
}

export default SignupPage;
